import SavedQuestionsPage from "./SavedQuestionsPage";

export default SavedQuestionsPage;